<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Group </ng-container>
    <ng-container cm-content>
        <cm-value-slot [node]="$node()" [key]="'active'" [label]="'Active'"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
